import { create } from 'zustand';
import type { DeviceSessionOutput } from './useDeviceSessionStream';

/**
 * The live session handle this browser tab started, per device UUID — IN MEMORY ONLY (the capability
 * token must never land in localStorage). Lives outside the drawer because Radix unmounts an inactive
 * tab and the drawer unmounts on close: without this, switching to Overview and back (or closing and
 * reopening the drawer) would strand a running session the operator can no longer see or end. Re-mounting
 * the live view just re-opens the SSE, which replays the transcript from seq 0 — no server-side resume.
 */
interface LiveSessionState {
  byDevice: Record<string, DeviceSessionOutput>;
  set: (deviceUuid: string, handle: DeviceSessionOutput) => void;
  clear: (deviceUuid: string) => void;
}

export const useLiveSessionStore = create<LiveSessionState>((set) => ({
  byDevice: {},
  set: (deviceUuid, handle) =>
    set((s) => ({ byDevice: { ...s.byDevice, [deviceUuid]: handle } })),
  clear: (deviceUuid) =>
    set((s) => {
      if (!(deviceUuid in s.byDevice)) return s;
      const next = { ...s.byDevice };
      delete next[deviceUuid];
      return { byDevice: next };
    }),
}));
